/**
 * 用户充值和额度管理 API 服务
 */

const API_BASE_URL = "/api";

/**
 * 额度信息
 */
export interface QuotaInfo {
  quota: number;
  used_quota: number;
  request_count: number;
  oneapi_token: string | null;
}

/**
 * 额度信息响应
 */
export interface QuotaInfoResponse {
  success: boolean;
  data: QuotaInfo;
  message: string;
}

/**
 * 充值响应
 */
export interface TopupResponse {
  success: boolean;
  data: {
    quotaAdded: number;
    newQuota: number;
  };
  message: string;
}

/**
 * 获取认证 token
 */
function getAuthHeaders(): HeadersInit {
  const authStore = localStorage.getItem("auth-storage");
  if (authStore) {
    const { state } = JSON.parse(authStore);
    const token = state?.accessToken;
    if (token) {
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    }
  }
  return {
    "Content-Type": "application/json",
  };
}

/**
 * 获取用户额度信息
 */
export async function getQuotaInfo(): Promise<QuotaInfoResponse> {
  const response = await fetch(`${API_BASE_URL}/user/quota`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "获取额度信息失败");
  }

  return response.json();
}

/**
 * 使用兑换码充值
 */
export async function topupWithCode(code: string): Promise<TopupResponse> {
  const response = await fetch(`${API_BASE_URL}/user/topup`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ code }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "充值失败");
  }

  return response.json();
}

/**
 * 格式化数字显示
 */
export function formatQuotaNumber(quota: number): string {
  return quota.toLocaleString();
}
